import { CountrySheetsList, CountrySheetsListLoader } from './CountrySheetsList.component';
import { ServiceCommonLayout } from 'features/services/components/ServiceCommonLayout/ServiceCommonLayout.component';
import { CountrySheetsContext } from 'pages/les-outils/fiches-pays-vin';
import React, { ComponentPropsWithRef, FC, useContext } from 'react';
import { useSelector } from 'react-redux';
import { BecomeProOverlay } from '@components/BecomeProOverlay/BecomeProOverlay.component';
import { userSelectors } from '@user/business/User.store';

type Props = ComponentPropsWithRef<'main'>;

const CountrySheetsLayout: FC<Props> = props => {
  const {
    sheets: { data, isValidating },
    news: { data: news, isValidating: isNewsLoading },
  } = useContext(CountrySheetsContext);
  const isPro = useSelector(userSelectors.isPro);

  return (
    <ServiceCommonLayout
      i18nServiceSubTitle="services.country-sheets.page-subtitle"
      i18nServiceTitle="services.country-sheets.page-title"
      isNewsLoading={isNewsLoading}
      news={news}
      serviceSlug="fiches-pays-vignes-et-vins"
      {...props}
    >
      {isPro ? (
        <>{isValidating ? <CountrySheetsListLoader /> : <CountrySheetsList sheets={data || []} />}</>
      ) : (
        <BecomeProOverlay asOverlay={false} i18nTitle="services.become-pro.title.vin.vigne" />
      )}
    </ServiceCommonLayout>
  );
};

export { CountrySheetsLayout };
